import { render, staticRenderFns } from "./EaVgasGameList.vue?vue&type=template&id=256e9912&lang=pug&"
import script from "./EaVgasGameList.vue?vue&type=script&lang=js&"
export * from "./EaVgasGameList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports